const {unauthorizedRedirect} = require('../auth');
const cookie = require('react-cookie');
const request = require('superagent-use')(require('superagent'));
const Promise = require('es6-promise').Promise;
require('superagent-auth-bearer')(request);

request.use(unauthorizedRedirect);

const EventsAndMetricsApi = {
  get: url => {
    let token = cookie.load('JWT');
    return new Promise((resolve, reject) => {
      request
        .get(url)
        .authBearer(token)
        .timeout({response: 10000, deadline: 60000})
        .end((err, res) => {
          if (err || !res.ok)
            reject({ error: err, res: res });
          else
            resolve(res);
        });
    });
  },
  delete: url => {
    let token = cookie.load('JWT');
    return new Promise((resolve, reject) => {
      request
        .del(url)
        .authBearer(token)
        .end((err, res) => {
          if (err || !res.ok)
            reject({ error: err, res: res });
          else
            resolve(res);
        });
    });
  }
}

export default EventsAndMetricsApi;
